export default "__VITE_ASSET__CoCMeT33__"